import { LANGUAGE } from "@/common/utils/constants.js";

export const GOP_ITEM_PAGE = {
	[LANGUAGE.en.short]: {
		offerPresentation: 'Offer Presentation',
		sectorPresentation: "Industry Presentation",
		corporatePresentation: "Corporate Presentation",
		techPracticePresentation: "Tech Practice Presentation",
		partnershipPresentation: "Partnership Presentation",
		description: "Description",
		contact: "Contact",
		marketInsights: "Market Insights",
		clientNeeds: "Clients Need & Benefits",
		tips: "Tips & Tricks",
		relatedStories: "Client Success Stories",
		biggestMarket: "Biggest markets",
		fastestGrowingMarkets: "Fastest Growing Markets",
		followedBy: "Followed by ",
		competitors: "Competitors",
		solutions: "Solutions",
		marketOpportunities: "Market Opportunities",
		additionalNotes: "Additional Notes",
		keyHighlights: "KEY HIGHLIGHTS",
		benefits: "Benefits",
		needs: "Needs",
		recognitions: 'Akkodis Recognitions',
		click: 'Click to see',
		showMore: "Show More",
		showLess: "Show Less",
		aside: {
			globalSolutionOwner: 'owner',
			globalDeliveryLocation: "DELIVERY location",
			techPracticeAndSubPractices: "TECH PRACTICES ⯈ sub-tech PRACTICES",
			mainTechPracticeTooltip: 'Main Tech Practice',
			industryAndSubIndustry: 'INDUSTRY ⯈ sub-INDUSTRY',
			mainIndustryTooltip: 'Main Industry',
			serviceLineAndSubServiceLine: "TYPE OF BUSINESS ⯈ sub-type of business",
			mainClientPersona: "MAIN CLIENT persona",
			lifecycle: "LIFECYCLE",
			toolsAndFrameworks: "TOOLS/FRAMEWORKS",
			certificates: "CERTIFICATIONS",
			salesTrainingVideoLink: "SALES TRAINING VIDEO LINK",
			annualRevenue: "ANNUAL REVENUE",
			maturity: "MATURITY"
		},
		buttons: {
			download: "Download",
			pdf: "Low Definition (PDF)",
			ppt: "High Definition (PPT)",
			next: "Next",
			previous: 'Previous',
			page: "Page",
			of: 'of'
		},
		preview: "Preview",
		save: "Save",
		unsave: "Unsave",
		copyLink: "Copy Link",
		previewMode: "Preview Mode",
		lessThanAMinute: "Last saved less than a minute ago",
		edit: "Edit",
		submit: "Submit",
		optional: 'Optional',
		time: 'Last saved {minutes}m ago',
		unableToOpenPdf: "Unable to display a PDF file.",
		link: "LINK",
		reportProblemModal: {
			title: 'What seems to be the problem?',
			positiveButtonText: 'Send',
			negativeButtonText: 'Cancel',
			textFiledTitle: 'Please send us a message.'
		},
		contactGlobalOwner: {
			tooltip: 'Contact the Owners',
			title: 'Contact the Owners',
			positiveButtonText: 'Send',
			negativeButtonText: 'Cancel',
			textFiledTitle: 'Please write and send a message.',
			successNotificationMessage: 'Successfully sent a message to the Owners.'
		}
	},
	[LANGUAGE.de.short]: {
		offerPresentation: 'Angebotspräsentation',
		sectorPresentation: "Industry-Präsentation",
		corporatePresentation: "Unternehmenspräsentation",
		techPracticePresentation: "Tech Practice Präsentation",
		partnershipPresentation: "Partnerschaftspräsentation",
		description: "Beschreibung",
		contact: "Kontakt",
		marketInsights: "Markteinblicke",
		clientNeeds: "Kundenbedürfnisse und Vorteile",
		tips: "Tipps & Tricks",
		relatedStories: "Kundenerfolgsgeschichten",
		biggestMarket: "Größte Märkte",
		fastestGrowingMarkets: "Wachstumsstärkste Märkte",
		followedBy: "Gefolgt von ",
		competitors: "Wettbewerber",
		solutions: "Lösungen",
		marketOpportunities: "Marktchancen",
		additionalNotes: "Zusatzinformationen",
		keyHighlights: "Zentrale Highlights",
		benefits: "Vorteile",
		needs: "Bedürfnisse",
		recognitions: 'Akkodis-Anerkennungen',
		click: 'Hier klicken, um mehr zu sehen',
		showMore: "Mehr anzeigen",
		showLess: "Weniger anzeigen",
		aside: {
			globalSolutionOwner: "Eigentümer",
			globalDeliveryLocation: "DELIVERY-Standort",
			techPracticeAndSubPractices: "TECH PRACTICES ⯈ sub-tech PRACTICES",
			mainTechPracticeTooltip: 'Haupt-Tech Practice',
			industryAndSubIndustry: 'INDUSTRY ⯈ sub-INDUSTRY',
			mainIndustryTooltip: 'Haupt-Industry',
			serviceLineAndSubServiceLine: "GESCHÄFTSART ⯈ Unterart des Geschäfts",
			mainClientPersona: "Haupt-Client Persona",
			lifecycle: "Lebenszyklus",
			toolsAndFrameworks: "TOOLS/FRAMEWORKS",
			certificates: "Zertifizierungen",
			salesTrainingVideoLink: "Video-Link zum Sales Training",
			annualRevenue: "Jahresumsatz",
			maturity: "Reifegrad"
		},
		buttons: {
			download: "Download",
			pdf: "Niedrige Auflösung (PDF)",
			ppt: "Hohe Auflösung (PPT)",
			next: "Nächste",
			previous: 'Vorherige',
			page: "Seite",
			of: 'von'
		},
		preview: "Vorschau",
		save: "Speichern",
		unsave: "Nicht mehr speichern",
		copyLink: "Link kopieren",
		previewMode: "Vorschau-Modus",
		lessThanAMinute: "Zuletzt gespeichert vor weniger als einer Minute",
		edit: "Bearbeiten",
		submit: "Einreichen",
		optional: 'Optional',
		time: 'Zuletzt vor {minutes}m gespeichert',
		unableToOpenPdf: "PDF-Datei kann nicht angezeigt werden.",
		link: "Link",
		reportProblemModal: {
			title: 'Worin besteht das Problem??',
			positiveButtonText: 'Senden',
			negativeButtonText: 'Abbrechen',
			textFiledTitle: 'Bitte senden Sie uns eine Nachricht..'
		},
		contactGlobalOwner: {
			tooltip: 'Eigentümer kontaktieren ',
			title: 'Eigentümer kontaktieren',
			positiveButtonText: 'senden',
			negativeButtonText: 'abbrechen',
			textFiledTitle: 'Bitte schreiben und senden Sie uns eine Nachricht.',
			successNotificationMessage: 'Nachricht erfolgreich an die Owners gesendet.'
		}
	},
	[LANGUAGE.fr.short]: {
		offerPresentation: 'Présentation de l\'offre',
		sectorPresentation: "Présentation de l'industrie",
		corporatePresentation: "Présentation institutionnelle",
		techPracticePresentation: "Présentation de la pratique technologique",
		partnershipPresentation: "Présentation du partenariat",
		description: "Description",
		contact: "Contact",
		marketInsights: "Marché",
		clientNeeds: "Besoins & avantages clients",
		tips: "Conseils",
		relatedStories: "Références client",
		biggestMarket: "Marchés les plus importants",
		fastestGrowingMarkets: "Marchés à forte croissance",
		followedBy: "Suivi de ",
		competitors: "Concurrents",
		solutions: "Solutions",
		marketOpportunities: "Opportunités de marché",
		additionalNotes: "Notes",
		keyHighlights: "Points forts",
		benefits: "Avantages",
		needs: "Besoins",
		recognitions: 'Récompenses Akkodis',
		click: 'Cliquer',
		showMore: "Afficher plus",
		showLess: "Afficher moins",
		aside: {
			globalSolutionOwner: "Propriétaire",
			globalDeliveryLocation: "Lieu de LIVRAISON",
			techPracticeAndSubPractices: "TECH PRACTICES ⯈ Sous-tech practices",
			mainTechPracticeTooltip: 'Practice technologique principale',
			industryAndSubIndustry: 'INDUSTRIES ⯈ Sous-industries',
			mainIndustryTooltip: 'Industrie principale',
			serviceLineAndSubServiceLine: "TYPE D'ACTIVITÉ ⯈ Sous-type d'activité",
			mainClientPersona: "Profil client",
			lifecycle: "Cycle de vie",
			toolsAndFrameworks: "OUTILS",
			certificates: "Certifications",
			salesTrainingVideoLink: "LIEN VIDÉO DE FORMATION",
			annualRevenue: "REVENUS ANNUELS",
			maturity: "MATURITÉ"
		},
		buttons: {
			download: "Télécharger",
			pdf: "Basse définition (PDF)",
			ppt: "Haute définition (PPT)",
			next: "Suivant",
			previous: 'Précédent',
			page: "Page",
			of: 'de'
		},
		preview: "Aperçu",
		save: "Enregistrer",
		unsave: "Annuler l'enregistrement",
		copyLink: "Copier",
		previewMode: "Aperçu",
		lessThanAMinute: "Dernière sauvegarde",
		edit: "Éditer",
		submit: "Soumettre",
		optional: 'Facultatif',
		time: 'Dernier enregistrement il y a {minutes}m',
		unableToOpenPdf: "Impossible d'afficher un fichier PDF.",
		link: "LIEN",
		reportProblemModal: {
			title: 'Quel est le le problème?',
			positiveButtonText: 'Envoyer',
			negativeButtonText: 'Annuler',
			textFiledTitle: 'Envoyez-nous un message'
		},
		contactGlobalOwner: {
			tooltip: 'Contacter les propriétaires',
			title: 'Contacter les propriétaires',
			positiveButtonText: 'Envoyer',
			negativeButtonText: 'Annuler',
			textFiledTitle: 'Envoyez-nous un message.',
			successNotificationMessage: 'Message envoyé avec succès aux propriétaires.'
		}
	},
	[LANGUAGE.it.short]: {
		offerPresentation: 'Presentazione dell\'offerta',
		sectorPresentation: "Presentazione del settore",
		corporatePresentation: "Presentazione aziendale",
		techPracticePresentation: "Presentazione della pratica tecnologica",
		partnershipPresentation: "Presentazione della partnership",
		description: "Descrizione",
		contact: "Contatto",
		marketInsights: "Approfondimenti di mercato",
		clientNeeds: "Necessità e vantaggi dei clienti",
		tips: "Suggerimenti e trucchi",
		relatedStories: "Storie di successo dei clienti",
		biggestMarket: "MERCATI PIÙ GRANDI",
		fastestGrowingMarkets: "Mercati in più rapida crescita",
		followedBy: "Seguito da ",
		competitors: "Concorrenti",
		solutions: "Soluzioni",
		marketOpportunities: "Opportunità di mercato",
		additionalNotes: "Note aggiuntive",
		keyHighlights: "PUNTI PRINCIPALI",
		benefits: "Benefici",
		needs: "esigenze",
		recognitions: 'Riconoscimenti di Akkodis',
		click: 'Clicca per vedere',
		showMore: "Mostra di più",
		showLess: "Mostra di meno",
		aside: {
			globalSolutionOwner: 'Proprietario',
			globalDeliveryLocation: "Posizione di CONSEGNA",
			techPracticeAndSubPractices: "PRATICHE TECNICHE ⯈ PRATICHE sub-tecnologiche",
			mainTechPracticeTooltip: 'Pratica tecnica principale',
			industryAndSubIndustry: 'INDUSTRIA ⯈ sotto-INDUSTRIA',
			mainIndustryTooltip: 'Industria principale',
			serviceLineAndSubServiceLine: "TIPO DI ATTIVITÀ ⯈ Sottotipo di attività",
			mainClientPersona: "Persona del CLIENTE PRINCIPALE",
			lifecycle: "CICLO VITALE",
			toolsAndFrameworks: "STRUMENTI/QUADRI",
			certificates: "CERTIFICAZIONI",
			salesTrainingVideoLink: "LINK VIDEO FORMAZIONE SULLA VENDITA",
			annualRevenue: "RICAVI ANNUALI",
			maturity: "MATURITÀ"
		},
		buttons: {
			download: "Scaricamento",
			pdf: "Bassa definizione (PDF)",
			ppt: "Alta definizione (PPT)",
			next: "Prossimo",
			previous: 'Precedente',
			page: "Pagina",
			of: 'di'
		},
		preview: "Anteprima",
		save: "Salvare",
		unsave: "Non salvare",
		copyLink: "Copia il link",
		previewMode: "Modalità anteprima",
		lessThanAMinute: "Ultimo salvataggio meno di un minuto fa",
		edit: "Modificare",
		submit: "Invia",
		optional: 'Opzionale',
		time: 'Ultimo salvataggio {minutes} milioni fa',
		unableToOpenPdf: "Impossibile visualizzare un file PDF.",
		link: "COLLEGAMENTO",
		reportProblemModal: {
			title: 'Quello che sembra essere il problema?',
			positiveButtonText: 'Inviare',
			negativeButtonText: 'Annulla',
			textFiledTitle: 'Per favore mandaci un messaggio'
		},
		contactGlobalOwner: {
			tooltip: 'Contatta i proprietari',
			title: 'Contatta i proprietari',
			positiveButtonText: 'Inviare',
			negativeButtonText: 'Annulla',
			textFiledTitle: 'Per favore scrivi e invia un messaggio.',
			successNotificationMessage: 'Messaggio inviato con successo ai proprietari.'
		}
	},
	[LANGUAGE.ja.short]: {
		offerPresentation: 'オファープレゼンテーション',
		sectorPresentation: "業界プレゼンテーション",
		corporatePresentation: "企業プレゼンテーション",
		techPracticePresentation: "技術実践の紹介",
		partnershipPresentation: "パートナーシップの紹介",
		description: "説明",
		contact: "接触",
		marketInsights: "市場洞察",
		clientNeeds: "クライアントのニーズとメリット",
		tips: "ヒントとコツ",
		relatedStories: "クライアントの成功事例",
		biggestMarket: "最大の市場",
		fastestGrowingMarkets: "急成長している市場",
		followedBy: "に続く ",
		competitors: "競合他社",
		solutions: "ソリューション",
		marketOpportunities: "市場機会",
		additionalNotes: "その他の注意事項",
		keyHighlights: "主なハイライト",
		benefits: "利点",
		needs: "ニーズ",
		recognitions: 'Akkodis の表彰',
		click: 'クリックして見る',
		showMore: "もっと見る",
		showLess: "もっと少なく見る",
		aside: {
			globalSolutionOwner: 'オーナー',
			globalDeliveryLocation: "配達場所",
			techPracticeAndSubPractices: "技術的実践 ⯈ サブ技術的実践",
			mainTechPracticeTooltip: '主な技術実践',
			industryAndSubIndustry: '産業 ⯈ サブ産業',
			mainIndustryTooltip: '主な産業',
			serviceLineAndSubServiceLine: "業種 ⯈ 業種のサブタイプ",
			mainClientPersona: "メインクライアントのペルソナ",
			lifecycle: "ライフサイクル",
			toolsAndFrameworks: "ツール/フレームワーク",
			certificates: "認証",
			salesTrainingVideoLink: "セールス トレーニング ビデオのリンク",
			annualRevenue: "年間収益",
			maturity: "成熟度"
		},
		buttons: {
			download: "ダウンロード",
			pdf: "低解像度 (PDF)",
			ppt: "高解像度 (PPT)",
			next: "次",
			previous: '前の',
			page: "ページ",
			of: 'の'
		},
		preview: "プレビュー",
		save: "保存",
		unsave: "保存解除",
		copyLink: "リンクをコピー",
		previewMode: "プレビューモード",
		lessThanAMinute: "最後に保存されたのは 1 分以内です",
		edit: "編集",
		submit: "提出する",
		optional: 'オプション',
		time: '最後に保存したのは {minutes} 分前です',
		unableToOpenPdf: "PDFファイルを表示できません。",
		link: "リンク",
		reportProblemModal: {
			title: '問題であると想定されるのは？',
			positiveButtonText: '送信',
			negativeButtonText: 'キャンセル',
			textFiledTitle: 'メッセージをお送りください。'
		},
		contactGlobalOwner: {
			tooltip: 'オーナーに連絡する',
			title: 'オーナーに連絡する',
			positiveButtonText: '送信',
			negativeButtonText: 'キャンセル',
			textFiledTitle: 'メッセージを書いて送信してください。',
			successNotificationMessage: 'オーナーへのメッセージ送信が正常に完了しました。'
		}
	},
	[LANGUAGE.es.short]: {
		offerPresentation: 'Presentación de la oferta',
		sectorPresentation: "Presentación del sector",
		corporatePresentation: "Presentación corporativa",
		techPracticePresentation: "Presentación de la práctica tecnológica",
		partnershipPresentation: "Presentación de la asociación",
		description: "Descripción",
		contact: "Contacto",
		marketInsights: "Análisis del mercado",
		clientNeeds: "Necesidades del cliente",
		tips: "Consejos",
		relatedStories: "Historias de éxito de clientes",
		biggestMarket: "Principales mercados",
		fastestGrowingMarkets: "Mercados de mayor crecimiento",
		followedBy: "Seguido por ",
		competitors: "Competidores",
		solutions: "Soluciones",
		marketOpportunities: "Oportunidades de mercado",
		additionalNotes: "Notas adicionales",
		keyHighlights: "Puntos clave",
		benefits: "Beneficios",
		needs: "Necesidades",
		recognitions: 'Reconocimientos de Akkodis',
		click: 'Haz clic para ver',
		showMore: "Mostrar más",
		showLess: "Mostrar menos",
		aside: {
			globalSolutionOwner: 'Propietario',
			globalDeliveryLocation: "Ubicación de la ENTREGA",
			techPracticeAndSubPractices: "PRÁCTICAS TECNOLÓGICAS ⯈ SUBPRÁCTICAS tecnológicas",
			mainTechPracticeTooltip: 'Práctica tecnológica principal',
			industryAndSubIndustry: 'INDUSTRIA ⯈ SUBINDUSTRIA',
			mainIndustryTooltip: 'Industria principal',
			serviceLineAndSubServiceLine: "TIPO DE NEGOCIO ⯈ Subtipo de negocio",
			mainClientPersona: "Perfil principal del cliente",
			lifecycle: "Ciclo de vida",
			toolsAndFrameworks: "HERRAMIENTAS/MARCOS DE TRABAJO",
			certificates: "Certificaciones",
			salesTrainingVideoLink: "VÍDEO DE FORMACIÓN EN VENTAS",
			annualRevenue: "INGRESOS ANUALES",
			maturity: "MADUREZ"
		},
		buttons: {
			download: "Descargar",
			pdf: "Baja definición (PDF)",
			ppt: "Alta definición (PPT)",
			next: "Siguiente",
			previous: 'Anterior',
			page: "Página",
			of: 'de'
		},
		preview: "Vista previa",
		save: "Guardar",
		unsave: "Eliminar guardado",
		copyLink: "Copiar enlace",
		previewMode: "Modo de vista previa",
		lessThanAMinute: "Guardado hace menos de un minuto",
		edit: "Editar",
		submit: "Enviar",
		optional: 'Opcional',
		time: 'Guardado hace {minutes} minutos',
		unableToOpenPdf: "No se puede mostrar un archivo PDF.",
		link: "Enlace",
		reportProblemModal: {
			title: '¿Cuál parece ser el problema?',
			positiveButtonText: 'Enviar',
			negativeButtonText: 'Cancelar',
			textFiledTitle: 'Por favor, envíenos un mensaje.'
		},
		contactGlobalOwner: {
			tooltip: 'Contactar con los propietarios',
			title: 'Contactar con los propietarios',
			positiveButtonText: 'Enviar',
			negativeButtonText: 'Cancelar',
			textFiledTitle: 'Por favor, escriba y envíe un mensaje.',
			successNotificationMessage: 'Mensaje enviado con éxito a los propietarios.'
		}
	}
}
